import { useEffect, useRef } from "react";
import "@css/NotFound.css";
import logo from "@images/logo_vanmieu.png";

const NotFound = () => {
    const sceneRef = useRef(null);

    useEffect(() => {
        // Import Parallax dynamically to avoid SSR issues
        const loadParallax = async () => {
            const Parallax = (await import("parallax-js")).default;
            if (sceneRef.current) {
                new Parallax(sceneRef.current);
            }
        };

        loadParallax();

        return () => {
            // Cleanup if needed
        };
    }, []);

    const handleDareClick = () => {
        // Navigate to homepage
        window.location.href = "/";
    };

    return (
        <main className="notfoud_page">
            {/* about */}
            <div className="about">
                <a
                    className="bg_links social portfolio"
                    href="/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="icon"></span>
                </a>
                <a
                    className="bg_links social dribbble"
                    href="/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="icon"></span>
                </a>
                <a
                    className="bg_links social linkedin"
                    href="/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="icon"></span>
                </a>
                <a className="bg_links logo"></a>
            </div>
            {/* end about */}

            <nav>
                <div className="menu">
                    <img
                        className="hover:cursor-pointer w-[80px]"
                        onClick={() => {
                            window.location.href = "/";
                        }}
                        src={logo}
                        loading="lazy"
                        alt="Logo"
                    />
                </div>
            </nav>

            <section className="wrapper">
                <div className="container">
                    <div
                        id="scene"
                        ref={sceneRef}
                        className="scene"
                        data-hover-only="false"
                    >
                        <div className="circle" data-depth="1.2"></div>

                        <div className="one" data-depth="0.9">
                            <div className="content">
                                <span className="piece"></span>
                                <span className="piece"></span>
                                <span className="piece"></span>
                            </div>
                        </div>

                        <div className="two" data-depth="0.60">
                            <div className="content">
                                <span className="piece"></span>
                                <span className="piece"></span>
                                <span className="piece"></span>
                            </div>
                        </div>

                        <div className="three" data-depth="0.40">
                            <div className="content">
                                <span className="piece"></span>
                                <span className="piece"></span>
                                <span className="piece"></span>
                            </div>
                        </div>

                        <p className="p404" data-depth="0.50">
                            404
                        </p>
                        <p className="p404" data-depth="0.10">
                            404
                        </p>
                    </div>

                    <div className="text">
                        <article>
                            <p>
                                Uh oh! Looks like you got lost. <br />
                                Go back to the homepage if you dare!
                            </p>
                            <button onClick={handleDareClick}>i dare!</button>
                        </article>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default NotFound;
